var initSearchInputListener = false;

function openCloseFilter(type) {
  if (type === 'close') {
    document.getElementById('filter-search').classList.remove('is-open');
    document.getElementById('page-algolia-container').classList.remove('open-filter');
  } else {
    document.getElementById('filter-search').classList.add('is-open');
    document.getElementById('page-algolia-container').classList.add('open-filter');
  }
}

function showProducts() {
  document.getElementById('app').style.display = 'flex';
  document.getElementById('page-algolia-container').classList.remove('h-fit-content');
  document.getElementById('page-algolia-container').classList.remove('search-empty');
  document.getElementById('search-suggestions').style.display = 'none';
  document.getElementById('algolia-result-search').style.display = 'block';
  document.getElementById('page-algolia-container').classList.remove('result_empty');
}

function hideProducts() {
  document.getElementById('app').style.display = 'none';
  document.getElementById('key_search').innerHTML = '';
  document.getElementById('predictive__loadmore').innerHTML = '';
  document.getElementById('page-algolia-container').classList.add('h-fit-content');
  document.getElementById('page-algolia-container').classList.add('search-empty');
  document.getElementById('page-algolia-container').classList.remove('result_empty');
  document.getElementById('search-suggestions').style.display = 'block';
  document.getElementById('algolia-result-search').style.display = 'none';
  document.getElementById('filter-search').innerHTML = '';
  document.getElementsByClassName('ais-SearchBox-input')[0].classList.add('empty_search');
}

function reviewInput(input) {
  if (input === '') {
    hideProducts();
  } else {
    showProducts();
    document.getElementById('key_search').innerHTML = '“' + input + '”';
  }
  window.scrollTo(0, 0);
}

function checkSearchInput() {
  try {
    try {
      if (!isMobile) {
        document.getElementById('search').style.setProperty('margin-top', '76px', 'important');
      }
    } catch (error) {
      console.log('[init] isMobile check error', error);
    }

    if (!initSearchInputListener) {
      var searchInput = document.getElementsByClassName('ais-SearchBox-input')[0];

      searchInput.addEventListener(
        'keyup',
        function () {
          // reviewInput(this.value);
          // document.getElementById('algolia-controller').style.display = 'none';
        },
        false
      );

      searchInput.addEventListener(
        'keydown',
        function (event) {
          if (event.key === 'Enter' || event.keyCode === 13) {
            event.preventDefault();
            document.querySelector('.ais-SearchBox-input').classList.add('active');
            if (document.getElementById('algolia-controller')) {
              if (document.getElementById('algolia-controller').classList.contains('result_empty')) {
                document.getElementById('algolia-controller').style.display = 'none';
              } else {
                document.getElementById('algolia-controller').style.display = 'block';
              }
            }
          } else {
            document.querySelector('.ais-SearchBox-input').classList.remove('active');
          }
        },
        false
      );

      initSearchInputListener = true;
    }
  } catch (error) {
    console.log('[init] checkSearchInput error', error);
  }
}

// Toggle search
function toggleSearch1() {
  // Reset cart drawer, menu
  document.querySelector('body').classList.remove('fix');
  document.querySelector('cart-drawer').classList.remove('is-open');
  document.querySelector('.main-menu-mobile').classList.remove('open');
  document.querySelector('#menuOverlay').classList.remove('open');
  document.querySelectorAll('.cart-open-trigger').forEach((e) => e.classList.remove('is-open'));
  document.querySelector('customer-drawer').classList.remove('is-open');

  checkSearchInput();

  // Only if desktop
  var menu = document.getElementById('mainMenu');
  var searchCointainer = document.getElementById('page-algolia-container');
  var hasClass = searchCointainer.classList.contains('is-open');

  document.querySelectorAll('.rocket-header__megamenu.pad-100').forEach((menu) => {
    menu.style.display = 'none';
  });

  setTimeout(() => {
    document.querySelector('.ais-SearchBox-input').focus();
  }, 300);

  if (!hasClass) {
    searchCointainer.classList.add('is-open');
    document.querySelector('body').classList.add('not-scroll');

    document.getElementById('openHamburguerMobile').style.display = 'none';
    document.getElementById('closeHamburguerMobile').style.display = 'block';

    document.getElementById('close-algolia')?.classList.remove('hidden');
    document.querySelector('.rocket-announcement_bar').classList.add('not-show-desktop');

    setTimeout(function () {
      menu.classList.add('searchactive');

      $('.ais-SearchBox-input').focus();
      if (document.getElementById('sc-bg')) {
        document.getElementById('sc-bg').classList.add('hide-searchbox');
      }
      document.getElementById('serch-container').click();
    }, 500);
  } else {
    searchCointainer.classList.remove('is-open');
    document.querySelector('body').classList.remove('not-scroll');

    document.getElementById('openHamburguerMobile').style.display = 'block';
    document.getElementById('closeHamburguerMobile').style.display = 'none';

    if (document.getElementById('close-algolia')) {
      document.getElementById('close-algolia').classList.add('hidden');
    }
    document.querySelector('.rocket-announcement_bar').classList.remove('not-show-desktop');
    menu.classList.remove('searchactive');
    document.getElementById('secondLevelMenu').style.display = 'block';

    document.getElementById('sc-bg').classList.remove('hide-searchbox');
    document.body.style.setProperty('overflow-y', 'auto');
  }
}

const containerSearchModal = document.getElementById('page-algolia-container');
containerSearchModal.addEventListener('click', (e) => {
  if (window.innerWidth < 768) {
        document.querySelector('.rocket-header')?.setAttribute('data-transparent', 'false');
    }
  if (e.target.contains(containerSearchModal)) {
    toggleSearch1();
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const searchContainer = document.getElementById('page-algolia-container');
  const input = document.querySelector('#rocket-Searchinput');
  const resultsContainer = document.getElementById('predictive-search-results');
  const btnLoadMore = document.getElementById('predictive__loadmore');
  const number = document.getElementById('number_results');
  const numberMb = document.getElementById('number_results_mobile');
  const filterContainer = document.getElementById('filter-search');

  let debounceTimer;
  let nextPageURL = null;
  let isFetching = false;

  // === Locale-aware prefix (fix idioma) ===
  const localePrefix =
    window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';

  async function fetchProducts(url, isLoadMore = false) {
    try {
      isFetching = true;
      const response = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });

      const html = await response.text();

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const searchFetch = doc.querySelector('.predictive-search-modal');

      if (searchFetch) {
        const count = searchFetch.getAttribute('data-count');
        number.innerText = count;
        numberMb.innerText = count;

        const newProducts = doc.querySelectorAll('.rocket-card-search');
        const newLoadMoreBtn = doc.querySelector('.loadMoresearch');
        const filterSearch = doc.querySelector('#SearchFilters');

        if (!isLoadMore) resultsContainer.innerHTML = ''; // clear for new search

        newProducts.forEach((product, idx) => {
          resultsContainer.appendChild(product.cloneNode(true));
          showProducts();
        });

        if (filterSearch) {
          // Evitar duplicar filtros
          filterContainer.innerHTML = '';
          filterContainer.appendChild(filterSearch.cloneNode(true));
        }

        btnLoadMore.innerHTML = '';
        if (newLoadMoreBtn) {
          btnLoadMore.appendChild(newLoadMoreBtn.cloneNode(true));
        } else {
          nextPageURL = null;
        }
      } else {
        document.querySelectorAll('.label-empty-search').forEach((item) => {
          item.style.display = 'block';
        });
        document.getElementById('predictive-search-results').innerHTML = '';
        hideProducts();
        document.getElementById('app').style.display = 'none';
        document.getElementById('page-algolia-container').classList.remove('h-fit-content');
        document.getElementById('page-algolia-container').classList.remove('search-empty');
        document.getElementById('page-algolia-container').classList.add('result_empty');
      }
    } catch (error) {
      console.error('Fetch products failed:', error);
    } finally {
      isFetching = false;
    }
  }

  input.addEventListener('input', async function () {
    const query = input.value.trim();
    clearTimeout(debounceTimer);

    if (query.length === 0) {
      resultsContainer.innerHTML = '';
      nextPageURL = null;
      return;
    }

    debounceTimer = setTimeout(() => {
      // >>> FIX: respeta el idioma actual usando el prefijo de Shopify <<<
      const searchUrl = `${localePrefix}search?type=product&q=${encodeURIComponent(query)}&view=ajax`;
      fetchProducts(searchUrl, false);
    }, 300);
  });

  // Infinite scroll
  searchContainer.addEventListener('scroll', () => {
    const scrollY = searchContainer.scrollTop;
    const viewportHeight = searchContainer.clientHeight;
    const totalHeight = searchContainer.scrollHeight;
    const nearBottom = scrollY + viewportHeight >= totalHeight - 200;

    if (nearBottom && !isFetching) {
      const nextBtn = document.querySelector('#paginateNext');
      if (nextBtn) {
        nextPageURL = nextBtn.getAttribute('href');
        // Asegura que la siguiente URL también use el prefijo de idioma si viniera sin él
        if (nextPageURL && nextPageURL.startsWith('/search')) {
          nextPageURL = `${localePrefix}${nextPageURL.replace(/^\//, '')}`;
        }
        fetchProducts(nextPageURL, true);
      }
    }
  });
});
